import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from '../auth/services';
import { AuthService } from '../auth/services/auth.service';

@Injectable({
	providedIn: 'root',
})
export class AuthResolver {
	constructor(
		private authService: AuthService,
		private appStateService: AppStateService,
		private router: Router,
	) {}

	async resolve(): Promise<boolean> {
		try {
			const res = await this.authService.getAuthFields();
			if (res.token && res.refreshToken && res.loggedInUser) {
				this.authService.setAuthFields(res.token, res.refreshToken, res.loggedInUser);

				return true;
			}
		} catch (e) {
			// nothing
		}

		this.router.navigate(['/']);
		return false;
	}
}
